import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import LoadingSpinner from "@/components/common/common/LoadingSpinner";
import NoData from "@/components/common/common/Nodata";
import Pagination from "@/components/user/common/Pagination";
import TitleBox from "@/components/user/common/TitleBox";
import { IBoardListParams } from "@/constants/common/listParams";
import usePagination from "@/hooks/common/usePagination";
import { useUrlParams } from "@/hooks/common/useUrlParams";
import { useGetBoardList } from "@/service/user/board";

interface Item {
    idx: number;
    num: number | string;
    b_title: string;
    b_reg_date: string;
}

export default function Board() {
    const { category } = useParams();
    // URL 파라미터 관리
    const { params, updateParams } = useUrlParams<IBoardListParams>({
        page: { defaultValue: 1, type: "number" },
    });
    const [totalPages, setTotalPages] = useState(1);
    const { currentPage, pages, setCurrentPage } = usePagination({ totalPages, initialPage: params.page });
    const [items, setItems] = useState<Item[]>([]);
    const { data: configData, isLoading: isInitialLoading } = useGetBoardList(
        category || "",
        "10",
        params.page.toString(),
        "title",
        "",
        { enabled: Boolean(category) },
    );

    // currentPage 변경 시 URL 파라미터 업데이트
    const handleChangeCurrentPage = (page: number) => {
        updateParams({
            page: page,
        });
        setCurrentPage(page);
    };

    // 게시글 목록 조회
    useEffect(() => {
        if (configData) {
            const data = configData.data;
            setItems(data.board_list);
            setTotalPages(data.last_page);
        } else {
            setItems([]);
            setTotalPages(1);
        }
    }, [configData]);

    return (
        <div className="mx-auto w-full max-w-[1400px] px-[20px] xl:px-0">
            <TitleBox
                title={category === "166" ? "NOTICE" : "NEWS & RESOURCES"}
                text={category === "166" ? "공지사항" : "관련자료"}
            />
            <div className="p-[28px_0_100px] md:p-[48px_0_160px]">
                <div className="rounded-[20px] bg-white p-[20px] md:p-[40px] xl:rounded-[40px] xl:p-[60px]">
                    {isInitialLoading ? (
                        <div className="py-[40px]">
                            <LoadingSpinner />
                        </div>
                    ) : items.length > 0 ? (
                        <>
                            <ul className="border-t border-black">
                                {items.map((item, i) => {
                                    let date = "";
                                    let day = "";
                                    try {
                                        const [year, month, dayStr] = item.b_reg_date.split(".");
                                        if (year && month && dayStr) {
                                            date = `${year}.${month}`;
                                            day = dayStr;
                                        }
                                    } catch (error) {
                                        console.error("날짜 처리 에러:", error);
                                    }
                                    return (
                                        <li
                                            key={`notice_${i}`}
                                            className="flex flex-col gap-[8px] border-b border-[#ddd] py-[15px] md:flex-row md:items-center md:gap-[30px] md:py-[25px]"
                                        >
                                            {category !== "171" && (
                                                <div className="flex items-center text-[14px] font-[600] text-black md:w-[10%] md:flex-col md:text-[16px]">
                                                    <p className="order-2 md:order-1 md:text-[32px]">
                                                        <span className="md:hidden">.</span>
                                                        {day || "-"}
                                                    </p>
                                                    <p className="md:order-2">{date || "-"}</p>
                                                </div>
                                            )}
                                            <Link
                                                to={`/community/${category}/${item.idx}`}
                                                className={`flex items-center gap-[8px] md:w-[calc(90%-30px)] md:gap-[16px] xl:w-[calc(77%-60px)]${category === "171" ? " flex-1" : ""}`}
                                            >
                                                {item.num === "공지" && (
                                                    <strong className="w-[50px] rounded-[20px] bg-primary text-center text-[14px] font-[700] leading-[24px] text-white md:w-[60px] md:text-[16px] md:leading-[30px]">
                                                        공지
                                                    </strong>
                                                )}
                                                <span className="flex-1 truncate text-[18px] text-black md:text-[20px]">
                                                    {item.b_title}
                                                </span>
                                            </Link>
                                            <p className="hidden w-[13%] text-center font-[500] text-black xl:block">
                                                GXG 운영사무국
                                            </p>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="flex justify-center p-[40px_0_20px]">
                                <Pagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    pages={pages}
                                    handleChangePage={handleChangeCurrentPage}
                                />
                            </div>
                        </>
                    ) : (
                        <NoData />
                    )}
                </div>
            </div>
        </div>
    );
}
